import { DarkButton } from 'components/buttons/DarkButton';
import { useAddFundsDrawer } from 'hooks/useAddFundsDrawer';

export const AddFundsButton = (): JSX.Element => {
    const [open] = useAddFundsDrawer();

    return <DarkButton textId="addFunds" onClick={() => open('addFunds')} />;
};
